import React from 'react';
import PoolCard from 'features/SpilKlub/components/PoolCard';
import useScreens, { POOL_DETAILS_SLUG } from '../screens/useScreens';
import { timeToUTC } from '../state/helpers';

const sortByPoolId = (a, b) => {
    return timeToUTC(a.pool.created) < timeToUTC(b.pool.created) ? 1 : -1;
};

const Pools = ({ pools }) => {
    const { group, activeBets, finishedBets } = pools;
    const { setScreen } = useScreens();
    const onClick = (poolHash) => setScreen(POOL_DETAILS_SLUG, poolHash);

    return (
        <>
            {activeBets.length > 0 && (
                <div className={'sk-active-games'}>
                    <p className={'no-margin'}>Aktive spil</p>
                    {activeBets.sort(sortByPoolId).map((item, index) => (
                        <PoolCard
                            item={item}
                            key={`active-${index}`}
                            groupName={group.name}
                            onClick={() => onClick(item.pool.poolHash)}
                        />
                    ))}
                </div>
            )}

            {finishedBets.length > 0 && (
                <div className={'sk-finished-games'}>
                    <p className={'no-margin'}>Afsluttede spil</p>
                    {finishedBets.sort(sortByPoolId).map((item, index) => (
                        <PoolCard
                            item={item}
                            key={`finished-${index}`}
                            groupName={group.name}
                            onClick={() => onClick(item.pool.poolHash)}
                            finished
                        />
                    ))}
                </div>
            )}
        </>
    );
};

export default Pools;
